module.exports = __webpack_public_path__ + "static/media/25k.1d779e7a.svg";